import { MutationFn } from '@percent/grants-nomination-form/hooks';
import { DEFAULT_LOCALE } from '@percent/grants-nomination-form/i18n/resources';
import { mapSupportedLocales } from '@percent/grants-nomination-form/i18n/utils/mapSupportedLocales';
import { SubmitApplicationFormParams } from './applicationForm.types';

export const submitApplicationFormAction: MutationFn<SubmitApplicationFormParams, void> = async (
  client,
  { programId, data, locale = DEFAULT_LOCALE },
) => {
  await client.post<void>(`v1/grants/programs/${programId}/candidate`, {
    ...data,
    locale: mapSupportedLocales(locale),
  });
};
